import {Component,ViewChild,ElementRef} from '@angular/core';
@Component({
  selector: 'app-sidebar-left-inner',
  templateUrl: './sidebar-left-inner.component.html'
})
export class SidebarLeftInnerComponent {
}
